import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import AbcIcon from '@mui/icons-material/Abc';
import { Box, Button, FormControl, FormLabel, Paper, Typography } from '@mui/material';
import React from 'react';
import { buildEventTab, buildGeneralTab, buildHiddenTab, buildStyleTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { FormHelperErrorDescription } from '../WidgetForm/Components';
import { defaultWidgetLabelProvider, getLabelAndValuePairs, getVisibleError, handleWidgetUpdate, isSkipValidate, joinLabels, makeNewConfigUnique, renderForm, validateCustom, } from '../WidgetForm/Utils';
import { TemplateOutput } from '../WidgetFormContent/Components';
import { TemplateEditor } from './Components';
import { type } from './types';
const WidgetFormTemplate = (props) => {
    var _a, _b;
    const value = getData(props);
    const error = getVisibleError(props);
    return (React.createElement(FormControl, { fullWidth: true, variant: 'outlined', size: 'medium', error: !!error },
        React.createElement(FormLabel, { sx: { marginBottom: 0.5 }, error: !!error }, props.config.label),
        React.createElement(Paper, { variant: 'outlined', sx: { p: 2 } },
            React.createElement(Typography, { component: 'div', "data-test": 'preview' },
                React.createElement(TemplateOutput, { template: value, props: props, editMode: true }))),
        React.createElement(Box, { pt: 1 },
            React.createElement(Button, { variant: 'outlined', onClick: () => {
                    props.internalData.edit = true;
                    props.update();
                    renderForm(props);
                }, "data-test": 'edit-button', autoFocus: (_a = (!props.editMode && props.config.autoFocus)) !== null && _a !== void 0 ? _a : false }, "Edit")),
        React.createElement(FormHelperErrorDescription, { error: error }),
        React.createElement(TemplateEditor, { props: (_b = props.config.props) !== null && _b !== void 0 ? _b : props, open: !!props.internalData.edit, template: value, onCancel: () => {
                delete props.internalData.edit;
                props.update();
                renderForm(props);
            }, onSave: (template) => {
                delete props.internalData.edit;
                props.setData(template);
                renderForm(props, { changed: true, autoSaveImmediately: props.config.autoSave });
            } })));
};
function getData(props) {
    var _a;
    return (_a = props.getData()) !== null && _a !== void 0 ? _a : {};
}
const WidgetFormTemplateEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, { title: 'Template: ' + props.config.label }, buildGeneralTab(props, {
            key: true,
            label: true,
            disabled: true,
            autoFocus: true,
        }), buildHiddenTab(props), buildStyleTab(props), buildEventTab(props, { eventOnChange: true, autoSave: true })) }),
        React.createElement(WidgetFormTemplate, Object.assign({}, props))));
};
export const widgetFormTemplate = {
    type,
    validate: (props) => {
        if (isSkipValidate(props)) {
            return;
        }
        const value = getData(props);
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    getLabelValueAsTextPairs: (props, labelPrefix) => {
        return getLabelAndValuePairs(joinLabels(labelPrefix, props.config.label), props.getDataStringOrUndefined());
    },
    component: WidgetFormTemplate,
    icon: React.createElement(AbcIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormTemplateEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'template', label: 'Template' }),
};
